// extracted by mini-css-extract-plugin
module.exports = {"warning":"_3dO1Bx","warningIcon":"_3NY5RR","warningText":"_1Lt-fO"};